module.exports = require("./bg-BG.js");